import { ExternalLink } from 'lucide-react';
import type { LLLinkElement } from '../../types';

export function LinkElement({ element }: { element: LLLinkElement }) {
  return (
    <a
      href={element.url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-sm text-primary underline underline-offset-2 hover:no-underline"
    >
      {element.hyperlinkText}
      <ExternalLink className="h-3.5 w-3.5" aria-hidden />
    </a>
  );
}
